import React from 'react';
import { StyleSheet, Text, View } from 'react-native';

import { useConsumerQuery } from 'apollo/queries/autogenerate/hooks';
import Button from 'shared/modules/common/components/atoms/Button';

type Props = {
  handleSubmit: () => void;
};

const EditUserEmailMobileOTPSent = (props: Props) => {
  const { data } = useConsumerQuery({ fetchPolicy: 'cache-only' });

  return (
    <>
      <View style={style.topContainer}>
        <Text style={style.textTitle}>
          {`ご登録の携帯電話番号に \n 認証コードを送信しました`}
        </Text>
        <View style={style.spacer} />
        {data ? (
          <Text style={style.subTitle}>
            {data?.consumer?.phone} に送信された
          </Text>
        ) : null}
        <Text style={style.subTitle}>4桁の認証コードを確認してください。</Text>
        <View style={style.spacer} />
        <Button
          title="次へ"
          onPress={props.handleSubmit}
          id="edit-user-email-next-button"
          style={style.button}
        />
      </View>
    </>
  );
};

const style = StyleSheet.create({
  textTitle: {
    fontSize: 20,
    fontWeight: '600',
    alignSelf: 'center',
  },
  topContainer: {
    flexGrow: 1,
    justifyContent: 'center',
  },
  subTitle: {
    alignSelf: 'center',
  },
  spacer: {
    marginBottom: 24,
  },
  button: {
    maxWidth: 296,
    alignSelf: 'center',
  },
});

export default EditUserEmailMobileOTPSent;
